/**
 * Ordering of Serach queries
 */
export enum SearchOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}
